import { UrlService } from "./../../../services/util/url.service";
import { Component, inject, DestroyRef } from '@angular/core';
import { BreadcrumbItem } from '../../../models/breadcrumb/breadcrumb-item';
import { translate } from '@jsverse/transloco';
import { FormUtilService } from 'src/app/services/util/form-util.service';
import { FormBuilder, FormControl, FormGroup, Validators, FormArray, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router} from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterSegments } from 'src/app/models/router-segments';
import { MatSelectChange } from '@angular/material/select';
import cloneDeep from 'lodash/cloneDeep';
import { MatChipInputEvent } from '@angular/material/chips';
import { COMMA, ENTER, SPACE } from '@angular/cdk/keycodes';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { TenantService } from 'src/app/services/api/tenant.service';
import moment from 'moment';
import { FeatureService } from 'src/app/services/api/feature.service'
import { trigger, transition, style, animate } from '@angular/animations';
import { EditTenantService } from 'src/app/services/api/edit-tenant.service';
import { CloudRegionService } from 'src/app/services/api/cloud-region.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { MatMenu } from '@angular/material/menu';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { Permissions } from 'src/app/models/principal/permission';
import { CloudProvider } from "src/app/models/cloud-provider/cloud-provider";

const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.TENANT_CREATE,
    action: Permissions.TENANT_CREATE,
  },
  {
    key: PermissionKeys.TENANT_UPDATE,
    action: Permissions.TENANT_UPDATE,
  }
]
@Component({
    selector: 'app-create-tenant-new',
    templateUrl: './create-tenant-new.component.html',
    styleUrls: ['./create-tenant-new.component.scss'],
    animations: [
        trigger('rotate', [
            transition('void=>*', [style({ transform: 'rotate(0)' })]),
            transition('* => *', [
                style({ transform: 'rotate(0)' }),
                animate('650ms ease-in-out', style({ transform: 'rotate(360deg)' })),
            ])
        ])
    ],
    standalone: false
})
export class CreateTenantNewComponent {
  private destroyRef = inject(DestroyRef);

  breadcrumbItems: BreadcrumbItem[];
  dashboardLink: any;
    detailsForm: FormGroup;
    cloudRegionForm: FormGroup;
    custInfoForm: FormGroup;
    settingsForm: FormGroup;
    isLoading = false;
    successMessage: any;
    numbers = ['Implementation', 'Live', 'Obsolete'];
    cloudRegion = ['Azure','AWS'];
    selectedRegion: any;
    saleschannels: any = ['Accelerate', 'Sandbox', 'SaaSContract'];
    minDate: Date;
    minEndDate: Date;
    visitedSteps = {
      stepOne: true,
      stepTwo: false,
      stepThree: false,
      stepFour: false,
      stepFive: false,
      stepSix: false
    };
    stepsArray = [1, 2, 3, 4, 5, 6];
    currentStep = 1;
    regionHeader: any = [
      {
        label: 'Region Pair',
        value: 'Region Pair',
        disabled: false
      },
      {
        label: 'Custom Region',
        value: 'Custom Region',
        disabled: false
      },
      {
        label: 'Single Region',
        value: 'Single Region',
        disabled: false
      }
    ];

    regions: any[] = [];

    startDateOption: any;
    emails = [];
    limit = 10;
    invalidEmail = [];
    scorecards: any = ['SaaS', 'Product', 'BSG'];
    addOnBlur = true;
    readonly separatorKeysCodes = [ENTER, COMMA, SPACE] as const;
    featuresForm: FormGroup;
    featureList: any;
    azurePrimaryRegion= [];
    azureSecondaryRegion = [];
    awsPrimaryRegion= [];
    awsSecondaryRegion = [];
    cloudProvider: string;
    regionPairs = [];
    azureRegionPairs = [];
    isRegionPairSelected = true;
    selectedRegionPair: any;
    customPriamryRegionValue: string;
    customSecondaryRegionValue: string;
    count: number;
    editTenantData: any;
    isEdit: boolean;
    primaryRegion = [];
    secondaryRegion = [];
    tooltipVisible = false;
    tooltipData: any = null;
    activeTooltipIndex: number | null = null;
    selectedSecondary: string;
    prodEdgeNetworkDeployed: any;
    singleRegionSelected: boolean;
    PermissionKeys = PermissionKeys;
    permissionsMap: { [key: string]: boolean; };
    noAwsRegions = false;

    constructor( public formBuilder: FormBuilder, private dialog: MatDialog, private router: Router, public authService: AuthService, private tenantService: TenantService,private featureService: FeatureService,
      private cloudRegionService: CloudRegionService, private toastrService: CustomToastrService,  private editTenantService: EditTenantService, private urlService: UrlService, private permissionService: PermissionsService
    ) {

    }
    tenantForm: FormGroup;
     hasSecondary: any = [
      {
        label: 'True',
        value: 'true'
      },
      {
        label: 'False',
        value: 'false'
      }
    ];


  ngOnInit(): void {
    this.permissionsMap = this.permissionService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    this.isEdit =   this.editTenantService.getIsEdit();
    if ((this.isEdit && !this.permissionsMap[PermissionKeys.TENANT_UPDATE]) || (!this.isEdit && !this.permissionsMap[PermissionKeys.TENANT_CREATE])) {
      this.router.navigate(['/', this.authService.principal.provider, 'permission-unauthorized'], {skipLocationChange: true});
    }
    this.regions = this.regionHeader;
    this.editTenantData = this.editTenantService.getData();
    this.cloudProvider = this.editTenantData?.cloudProvider || this.editTenantData?.targetCloud;
    this.selectedRegion = (this.editTenantData?.cloudProvider === 'Azure' || this.editTenantData?.targetCloud === 'Azure') && this.editTenantData?.regionPair!=="" ? this.regionHeader[0] : (this.editTenantData?.parameters?.hasSecondaryRegion === 'false' ? this.regionHeader[2] : this.regionHeader[1]);    
    this.isRegionPairSelected = (this.editTenantData?.cloudProvider === 'Azure' || this.editTenantData?.targetCloud === 'Azure') && this.editTenantData?.regionPair!=="" ? true:false;
    if (this.editTenantData?.targetCloud === CloudProvider.AWS || this.editTenantData?.cloudProvider === CloudProvider.AWS) {
      this.regions = this.regionHeader.filter(item => item.value !== 'Single Region');
      this.prodEdgeNetworkDeployed = (this.editTenantData?.sharedInfra?.prod?.status === 'completed' || this.editTenantData?.sharedServices?.prod?.status === 'completed')? true : false;
    } else {
      this.prodEdgeNetworkDeployed = (this.editTenantData?.sharedInfra?.prod?.instanceId || this.editTenantData?.sharedServices?.prod?.instanceId) ? true : false;
    }
      if(!this.prodEdgeNetworkDeployed && this.isEdit) {
        this.regionHeader[0].disabled = true;
      }
      if (this.selectedRegion.value === 'Single Region') {
          this.hasSecondary[0].value = 'false';
          this.hasSecondary[1].value = 'true';
          this.isRegionPairSelected = false;
          this.singleRegionSelected = true;          
          this.selectSecondary();
      } else {
        this.selectSecondary();
      }
    this.dashboardLink = ({label: translate('LEFT_SIDE_NAV.TENANT_ONBOARDING')});
    this.breadcrumbItems = [];
    // this.selectedSecondary = 'true';
    this.breadcrumbItems.push({icon: 'home'}, {label: this.dashboardLink.label, url:[]}, {label: translate('LEFT_SIDE_NAV.TENANT_ONBOARDING_TENANT'),
      url: ['tenant-onboarding']},  {label: translate('TENANT_FORM.NAME'),
      url: ['add-tenant']}, );

    this.detailsForm = this.formBuilder.group({
        tenantId: ["", Validators.required],
        ticketNumber: ["", Validators.required],
        status: [{ value: this.numbers[0], disabled: true}],
        tenantOwner: ["", [Validators.required,Validators.pattern(/^[a-zA-Z0-9._%+-]+@temenos\.com$/)]]

      });
      this.cloudRegionForm = this.formBuilder.group({
        cloudProvider: ["", [Validators.required]],
        regionPair: ["", [Validators.required]],
        primaryRegion: ["", [Validators.required]],
        secondaryRegion: ["", [Validators.required]]
      });
      this.custInfoForm = this.formBuilder.group({
        customerName: ["", [Validators.required]],
        customerNumber: ["", [Validators.required]],
        customerRegion: ["", [Validators.required]],
        customerCountry: ["", [Validators.required]],
        customerMnemonic: [""],
        scoreCard: ["", [Validators.required]],
        salesChannel: ["", [Validators.required]],
        contractEndDate: ["", [Validators.required]]
      });
      this.featureService.getTenantFeatures()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any) => {
        if (!this.isEdit) {
          this.featureList = data;
          this.featuresForm = this.formBuilder.group({
            features: this.formBuilder.array(
              this.featureList.map(feature => this.createFeatureFormGroup(feature))
            )
          });
        }
       });
      this.settingsForm = this.formBuilder.group({
        notificationEmails: [""]
      });


    if (this.isEdit) {
      this.getTenantIdFeatures(this.editTenantData?.tenantId);
      this.detailsForm.patchValue({
        tenantId: this.editTenantData?.tenantId,
        ticketNumber: this.editTenantData?.ticketNumber,
        status: this.editTenantData?.status,
        tenantOwner: this.editTenantData?.tenantOwner
      });
      this.cloudProvider = this.editTenantData?.cloudProvider || this.editTenantData?.targetCloud;
      if (this.cloudProvider === 'AWS') {
        this.loadAwsRegions();
      }
      this.cloudRegionForm.patchValue({
        cloudProvider: this.editTenantData?.cloudProvider || this.editTenantData?.targetCloud,
        regionPair: this.editTenantData?.regionPair,
        primaryRegion: this.editTenantData?.primaryRegion,
        secondaryRegion: this.editTenantData?.secondaryRegion
      });
      this.custInfoForm.patchValue({
        customerName: this.editTenantData?.customerName,
        customerNumber: this.editTenantData?.customerNumber,
        customerRegion: this.editTenantData?.customerRegion,
        customerCountry: this.editTenantData?.customerCountry,
        customerMnemonic: this.editTenantData?.customerMnemonic,
        scoreCard: this.editTenantData?.scoreCard,
        salesChannel: this.editTenantData?.salesChannel,
        contractEndDate: this.editTenantData?.contractEndDate
      });
      this.settingsForm = this.formBuilder.group({
        notificationEmails: [this.editTenantData?.notificationEmails || []]
      });

      this.detailsForm.get('tenantId').disable();
      this.detailsForm.get('ticketNumber').disable();
      this.detailsForm.get('status').enable();

      this.cloudRegionForm.get('cloudProvider').disable();
      this.cloudRegionForm.get('regionPair').disable();
      if(this.isEdit && this.prodEdgeNetworkDeployed) {
        this.cloudRegionForm.get('primaryRegion').disable();
        this.cloudRegionForm.get('secondaryRegion').disable();
      }

      this.custInfoForm.get('customerName').disable();
      this.custInfoForm.get('customerNumber').disable();
      this.custInfoForm.get('customerRegion').disable();
      this.custInfoForm.get('customerCountry').disable();
      this.custInfoForm.get('scoreCard').disable();
      this.custInfoForm.get('salesChannel').disable();

      }

      this.minDate = new Date();
      this.minEndDate = new Date();
      this.minEndDate.setDate(this.minDate.getDate() + 1);

    this.cloudRegionService.getTenantRegionPairs()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(regionPair => {
      this.azureRegionPairs = regionPair.filter(item=> item?.cloudProvider.toLowerCase() == 'azure');
      this.regionPairs = regionPair
      if (regionPair?.length > 0) {
        regionPair.forEach(element => {
          if (element.cloudProvider === 'azure') {
            this.azurePrimaryRegion.push(element.primaryRegion);
            this.azureSecondaryRegion.push(element.secondaryRegion);
          } else {
            this.awsPrimaryRegion.push(element.primaryRegion);
            this.awsSecondaryRegion.push(element.secondaryRegion);
          }

          if (this.cloudProvider === CloudProvider.AZURE) {
            this.loadAzureRegionsByType();
          } else {
            this.primaryRegion = this.awsPrimaryRegion;
            this.secondaryRegion = this.awsSecondaryRegion;
          }
        })

        if (this.editTenantData?.regionPair) {
          this.isRegionPairSelected = true;
          const regeinPairDetails = regionPair.filter(item=> (item?.cloudProvider?.toLowerCase() == this.editTenantData?.targetCloud?.toLowerCase() || item?.cloudProvider?.toLowerCase() == this.editTenantData?.cloudProvider?.toLowerCase()) && item?.name.toLowerCase() == this.editTenantData?.regionPair?.toLowerCase());
          this.cloudRegionForm.get('regionPair').setValue(this.editTenantData?.regionPair);
          this.cloudRegionForm.get('primaryRegion').setValue(regeinPairDetails[0]?.primaryRegion);
          this.cloudRegionForm.get('secondaryRegion').setValue(regeinPairDetails[0]?.secondaryRegion);
        }
      }

    },
    (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });

  }

  loadAwsRegions() {
    this.cloudRegionService.getTenantRegions().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res: any[]) => {
        const awsRegions = res.filter(r => r.cloudProvider?.toLowerCase() === 'aws');
         if (!awsRegions.length) {
          this.noAwsRegions = true;
          this.primaryRegion = [];
          this.secondaryRegion = [];
          return;
        }
        this.noAwsRegions = false;
        this.primaryRegion = awsRegions.map(r => ({name: r.name, displayName: r.displayName}));
        this.secondaryRegion = [...this.primaryRegion];
        if (this.isEdit) {
        this.cloudRegionForm.patchValue({
          primaryRegion: this.editTenantData?.primaryRegion,
          secondaryRegion: this.editTenantData?.secondaryRegion
        });
      }
    });
  }

  getZoneValue(feature: any, zone: string): boolean {
    const val = this.isEdit ? feature.dataZones?.find(z => z.dataZone === zone)?.enabled : feature.dataZones?.find(z => z.dataZone === zone)?.defaultEnabled;
    return val === 'true' || val === true;
  }

  getZoneModifiable(feature: any, zone: string): boolean {
    const val = feature.dataZones?.find(z => z?.dataZone === zone)?.modifiable;
    return val === 'true' || val === true;
  }

  get features(): FormArray {
    return this.featuresForm.get('features') as FormArray;
  }

    goToStep(currentStep, now?, previous?): void {
        if(now === 1 && !FormUtilService.validateForm(this.detailsForm)) {
            return;
        } else {
          if (this.currentStep === 2) {
            if(!previous) {
              this.visitedSteps.stepTwo = true;
              if(!this.isEdit){
              if(!FormUtilService.validateForm(this.cloudRegionForm)) {
                return;
              } else {
                if(!previous && (!this.isEdit || (this.isEdit && !this.prodEdgeNetworkDeployed)) && this.hasSecondary[1].value === 'true'){
                this.confirmRegion(currentStep);
              } else {
                  this.currentStep = currentStep;
                }
              }
            } else {
                if(!this.prodEdgeNetworkDeployed) {
                  this.selectRegion(this.selectedRegion);
                  if(!FormUtilService.validateForm(this.cloudRegionForm)) {
                    return;
                  }
                }
                if((!previous && !this.prodEdgeNetworkDeployed && this.hasSecondary[1].value === 'true' && !this.isEdit) || (this.isEdit && !this.editTenantData?.parameters?.hasSecondaryRegion && this.hasSecondary[1].value === 'true')){
                  this.confirmRegion(currentStep);
                } else {
                  this.currentStep = currentStep;
                }
              }
            }
          } else if (this.currentStep === 3) {
            if(!previous) {
              this.visitedSteps.stepThree = true;
              if(!FormUtilService.validateForm(this.custInfoForm)) {
                return;
              }
            }
          } else if (this.currentStep === 4) {
            this.visitedSteps.stepFour = true;
          } else if (this.currentStep === 5) {
            this.visitedSteps.stepFive = true;
          } else if (this.currentStep === 6) {
            this.visitedSteps.stepSix = true;
          }
          if(this.currentStep !== 2 || (this.currentStep === 2 && previous)){
            this.currentStep = currentStep;
          }
        }
      }

   goToTenant(): void {
    this.router.navigate(['/',this.authService.principal.provider,RouterSegments.TENANT_ONBOARDING]);
      }

      onSelectionChange(event: MatSelectChange) {
        this.cloudProvider = event.value;
        this.cloudProvider = event.value;
        if(event.value === 'Azure'){
          this.regions = [...this.regionHeader];
          this.selectedRegion = this.regionHeader.find(region => region.value === 'Region Pair');
        } else {
          this.regions = this.regionHeader.filter(item => item.value !== 'Single Region');
          this.selectedRegion = this.regionHeader.find(region => region.value === 'Custom Region');
        }
        this.selectRegion(this.selectedRegion);
      }

      /**
       * Apply the values to primary and secondary region based on region option selection
       * Add and remove the validation based on selected region option
       * @param option: the selected region
      */
      selectRegion(option: any) {
        this.selectedRegion = option;
        if (!this.isEdit) {
        this.cloudRegionForm.get('regionPair').setValue('');
        this.cloudRegionForm.get('primaryRegion').setValue('');
        this.cloudRegionForm.get('secondaryRegion').setValue('');
        }
        if (this.selectedRegion.value === 'Region Pair') {
          this.hasSecondary[1].value = 'false';
          this.hasSecondary[0].value = 'true';
          this.isRegionPairSelected = true;
          this.singleRegionSelected = false;
          this.selectSecondary();
          this.cloudRegionForm.get('regionPair').addValidators([Validators.required]);
          this.cloudRegionForm.get('regionPair').updateValueAndValidity();
          this.cloudRegionForm.get('primaryRegion').removeValidators([Validators.required]);
          this.cloudRegionForm.get('primaryRegion').updateValueAndValidity();
          this.cloudRegionForm.get('secondaryRegion').removeValidators([Validators.required]);
          this.cloudRegionForm.get('secondaryRegion').updateValueAndValidity();
          if (!this.isEdit) {
            this.cloudRegionForm.get('primaryRegion').setValue('');
            this.cloudRegionForm.get('secondaryRegion').setValue('');
          }
        } else if (this.selectedRegion.value === 'Single Region') {
          this.hasSecondary[0].value = 'false';
          this.hasSecondary[1].value = 'true';
          this.isRegionPairSelected = false;
          this.singleRegionSelected = true;
          this.selectSecondary();
          this.cloudRegionForm.get('regionPair').removeValidators([Validators.required]);
          this.cloudRegionForm.get('regionPair').updateValueAndValidity();
          this.cloudRegionForm.get('primaryRegion').addValidators([Validators.required]);
          this.cloudRegionForm.get('primaryRegion').updateValueAndValidity();
          this.cloudRegionForm.get('secondaryRegion').removeValidators([Validators.required]);
          this.cloudRegionForm.get('secondaryRegion').updateValueAndValidity();
          if(!this.isEdit) {
            this.cloudRegionForm.get('primaryRegion').setValue('');
            this.cloudRegionForm.get('secondaryRegion').setValue('');
          }
        } else {
          this.hasSecondary[1].value = 'false';
          this.hasSecondary[0].value = 'true';
          this.isRegionPairSelected = false;
          this.singleRegionSelected = false;
          this.selectSecondary();
          this.cloudRegionForm.get('regionPair').removeValidators([Validators.required]);
          this.cloudRegionForm.get('regionPair').updateValueAndValidity();
          this.cloudRegionForm.get('primaryRegion').addValidators([Validators.required]);
          this.cloudRegionForm.get('primaryRegion').updateValueAndValidity();
          this.cloudRegionForm.get('secondaryRegion').addValidators([Validators.required]);
          this.cloudRegionForm.get('secondaryRegion').updateValueAndValidity();
          if(!this.isEdit) {
            this.cloudRegionForm.get('primaryRegion').setValue('');
            this.cloudRegionForm.get('secondaryRegion').setValue('');
          }
        }
        if (this.cloudProvider === CloudProvider.AZURE) {
          this.loadAzureRegionsByType();
        } else {
          this.loadAwsRegions();
        }
      }


      /**
       * get the region and apply the values to primary and secondary region
       * @param event: the selected region pair
      */
      onRegionPairChange(event: MatSelectChange) {
        this.selectedRegionPair = event;
        const region = this.regionPairs.find((element)=> element.cloudProvider.toLowerCase() === this.cloudProvider.toLowerCase()
        && element.id.toLowerCase() === this.cloudProvider.toLowerCase()+'-'+event.value.toLowerCase());
        if (region) {
          this.cloudRegionForm.get('primaryRegion').setValue(this.editTenantData?.regionPair);
          this.cloudRegionForm.get('primaryRegion').setValue(region?.primaryRegion);
          this.cloudRegionForm.get('secondaryRegion').setValue(region?.secondaryRegion);
        } else {
          this.cloudRegionForm.get('primaryRegion').setValue('');
          this.cloudRegionForm.get('secondaryRegion').setValue('');
        }
      }

      /**
       * get the primary region
       * @param region: the selected value from primary region
      */
      onPrimaryRegionChange(event: MatSelectChange) {
          const selected = event.value;
          if (this.cloudRegionForm.get('secondaryRegion')?.value === selected) {
            this.cloudRegionForm.get('secondaryRegion').setValue('');
          }
      }

      /**
       * get the secondary region
       * @param region: the selected value from secondary region
      */
      onSecondaryRegionChange(region) {
        this.customSecondaryRegionValue = region.value;
      }
        contractEndDateChange(event): void {
            this.startDateOption = event.value;
            const result = cloneDeep(new Date(this.startDateOption));
            result.setDate(result.getDate() + 1);
            this.minEndDate = result;
          }

          get emailNotifications(): string[] {
            return this.settingsForm.get('notificationEmails').value || [];
          }

          set emailNotifications(val: string[]) {
            this.settingsForm.get('notificationEmails').setValue(val);
          }

          add(event: MatChipInputEvent): void {
            const value = (event.value || '').trim();

            if (value && this.emailNotifications.length < this.limit) {
              const normalizedEmails = this.emailNotifications.map(email => email.toLowerCase());

              if (!normalizedEmails.includes(value.toLowerCase())) {
                this.emailNotifications = [...this.emailNotifications, value];
              }
            }

            event.chipInput?.clear();
          }


            isValidEmail(email): boolean {
              const validateEmail = /^[a-zA-Z0-9._%+-]+@[A-Za-z0-9.-]+\.[a-z]{2,4}$/;
              const splitEmail = email.split('@');
              if (validateEmail.test(email) && splitEmail[1].toLowerCase() === 'temenos.com') {
                return true;
              } else {
                const emails = this.invalidEmail?.map(item => item.toLowerCase());
                const findDuplicate = emails.find(item => item === email.toLowerCase());
                if (!findDuplicate) {
                  this.invalidEmail.push(email);
                }
              }
            }

            remove(email: string): void {
              this.emailNotifications = this.emailNotifications.filter(e => e !== email);
              if (this.invalidEmail.includes(email)) {
                this.invalidEmail = this.invalidEmail.filter(e => e !== email);
              }
            }


            isAllEmailsValid(): boolean {
              return this.emailNotifications.every(email => this.isValidEmail(email));
            }


           private createTenant(): void {
                // if (tenantFormIsValid) {
                 if (!this.isEdit) {
                    this.dialog.open(ConfirmationDialogComponent, {
                      panelClass: 'default-dialog-wrapper',
                      width: '566px',
                      autoFocus: false,
                      data: {
                        title: translate('TENANT_FORM.TITLE'),
                        message:translate('TENANT_FORM.MESSAGE'),
                        confirmButtonText: translate('BUTTONS.CONFIRM')
                      }
                    })
                      .afterClosed()
                      .pipe(takeUntilDestroyed(this.destroyRef))
                      .subscribe(confirm => {
                        if (confirm) {
                        this.isLoading = true;
                        this.tenantForm = this.formBuilder.group({
                          ...this.detailsForm.controls,
                          ...this.custInfoForm.controls,
                          ...this.cloudRegionForm.controls,
                          ...this.settingsForm.controls
                        });
                        const tenant = this.tenantForm.getRawValue();
                        tenant.contractEndDate = moment(tenant.contractEndDate).utcOffset("+05:30").format("YYYY-MM-DD");
                        let instanceStopStartData = [];
                        if(tenant.nonpiiEnabled) {
                          instanceStopStartData.push('nonpii');
                        }
                        if(tenant.piiEnabled) {
                          instanceStopStartData.push('pii');
                        }
                        // if(tenant.prodEnabled) {
                        //   instanceStopStartData.push('prod');
                        // }
                        tenant.parameters = {
                          instanceStopStart: instanceStopStartData,
                          hasSecondaryRegion: this.selectedSecondary
                          // prodDeploymentClass: tenant.prodDeploymentClass
                        }
                        // delete tenant.prodDeploymentClass;
                        delete tenant.nonpiiEnabled;
                        delete tenant.piiEnabled;
                        // delete tenant.prodEnabled;
                        tenant.notificationEmails = this.emailNotifications;
                        this.tenantService.createTenant(tenant)
                        .pipe(takeUntilDestroyed(this.destroyRef))
                        .subscribe({
                          next: (res: any) => {
                           const featureTenant = this.featuresForm.getRawValue();
                          // patching the modified features in create flow
                            this.patchTenantIdFeatures(featureTenant, res.tenantId);
                            this.router.navigate(['/',this.authService.principal.provider,RouterSegments.TENANT_ONBOARDING]);
                            setTimeout(() => {
                                const title = translate('INSTANCE_STATUS.TENANT');
                                const message = translate('TENANT_FORM.TENANT_ADDED');
                                this.toastrService.successMessage(message, title);
                            }, 500);
                          },
                          error: (error) => {
                            this.isLoading = false;
                            const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
                            this.dialog.open(ErrorDialogComponent, {
                              minHeight: '342px',
                              width: '630px',
                              panelClass: 'flex-dialog',
                              data: {
                                title:  translate('ERROR_DIALOG.ADD_TENANT_FAILED'),
                                description: errorMessage
                              }
                            });

                          }
                        });
                      }
                    });
                  } else {
                      this.editTenant();
                    }


              }

              editTenant(){

                 this.dialog.open(ConfirmationDialogComponent, {
                      panelClass: 'default-dialog-wrapper',
                      width: '566px',
                      autoFocus: false,
                      data: {
                        title: translate('TENANT_LIST.UPDATE_TENANT'),
                        message:translate('TENANT_FORM.UPDATE_MESSAGE'),
                        confirmButtonText: translate('BUTTONS.CONFIRM')
                      }
                    })
                      .afterClosed()
                      .pipe(takeUntilDestroyed(this.destroyRef))
                      .subscribe(confirm => {
                        if (confirm) {
                        this.isLoading = true;
                        this.tenantForm = this.formBuilder.group({
                          ...this.detailsForm.controls,
                          ...this.custInfoForm.controls,
                          ...this.cloudRegionForm.controls,
                          ...this.settingsForm.controls
                        });
                        const tenant = this.tenantForm.getRawValue();
                        tenant.contractEndDate = moment(tenant.contractEndDate).utcOffset("+05:30").format("YYYY-MM-DD");
                        let instanceStopStartData = [];
                            if(tenant.nonpiiEnabled) {
                              instanceStopStartData.push('nonpii');
                            }
                            if(tenant.piiEnabled) {
                              instanceStopStartData.push('pii');
                            }
                            tenant.parameters = {
                              instanceStopStart: instanceStopStartData
                              // prodDeploymentClass: tenant.prodDeploymentClass
                            }
                            // delete tenant.prodDeploymentClass;
                            delete tenant.nonpiiEnabled;
                            delete tenant.piiEnabled;
                            tenant.notificationEmails = this.emailNotifications;
                            this.tenantService.updateTenant(tenant)
                        .pipe(takeUntilDestroyed(this.destroyRef))
                        .subscribe({
                          next: (res: any) => {
                            const featureTenant = this.featuresForm.getRawValue();
                            // patching the modified features in edit flow
                            this.patchTenantIdFeatures(featureTenant, res.tenantId);
                            this.router.navigate(['/',this.authService.principal.provider,RouterSegments.TENANT_ONBOARDING]);
                            setTimeout(() => {
                                const title = translate('INSTANCE_STATUS.TENANT');
                                const message = translate('TENANT_FORM.TENANT_UPDATED');
                                this.toastrService.successMessage(message, title);
                            }, 500);
                          },
                          error: (err) => {
                            this.isLoading = false;
                            this.dialog.open(ErrorDialogComponent, {
                              minHeight: '342px',
                              width: '630px',
                              panelClass: 'flex-dialog',
                              data: {
                                title:  translate('ERROR_DIALOG.EDIT_TENANT_FAILED'),
                                description: err?.errmsg? err.errmsg: err?.error
                              }
                            });
                          }
                        });
                      }
                    });

              }

              patchTenantIdFeatures(featureTenant, tenantId): void {
                let request = [];
                const features = featureTenant.features.filter(item => item.modifiable === true || item.modifiable === 'true');
                features.forEach(item => {
                  this.featureList.forEach(element => {
                    if(item.name === element.displayName){
                       item.name = element.name;
                    }
                  });
                  const obj: any = {};
                  obj.name = item.name;
                  obj.enabled = item.defaultEnabled;
                  const dataZone = ['nonpii', 'pii', 'prod'];
                  let dataZones = [];
                  dataZone.forEach(element => {
                    const dataZoneObj: any = {}
                    dataZoneObj.dataZone = element;
                    dataZoneObj.enabled = item[element];
                    if (this.featureList.find(elemt => elemt.name === item.name).dataZones?.find(elemt => elemt.dataZone === element)?.modifiable !== 'false' &&
                      this.featureList.find(elemt => elemt.name === item.name).dataZones?.find(elemt => elemt.dataZone === element)?.modifiable !== false) {
                        dataZones = [...dataZones, dataZoneObj];
                      }
                  })
                  obj.dataZones = dataZones;
                  request = [...request, obj];
                })
                const payload = {
                  tenantId,
                  features: request
                }
                this.featureService.patchTenantIdFeatures(payload).pipe(takeUntilDestroyed(this.destroyRef))
                  .subscribe(data => {
                    this.successMessage = true;
                    this.isLoading = false;
                  },
                  (error) => {
                    this.isLoading = false;
                    const errorMessage = typeof error.error === 'string' ? error.error : error;
                    this.dialog.open(ErrorDialogComponent, {
                      minHeight: '342px',
                      width: '630px',
                      panelClass: 'flex-dialog',
                      data: {
                        title:  this.isEdit ? translate('ERROR_DIALOG.EDIT_TENANT_FAILED') : translate('ERROR_DIALOG.ADD_TENANT_FAILED'),
                        description: errorMessage
                      }
                    });
                  })
              }

              // to get previously modified features for the tenant in edit flow
              getTenantIdFeatures(tenantId): void {
                this.featureService.getTenantIdFeatures(tenantId).pipe(takeUntilDestroyed(this.destroyRef))
                  .subscribe(response => {
                    this.featureList = response;
                    this.featuresForm = this.formBuilder.group({
                      features: this.formBuilder.array(
                        this.featureList.map(feature => this.createFeatureFormGroup(feature))
                      )
                    });
                  })
              }


               cancelTenant(): void {
                    this.dialog.open(ConfirmationDialogComponent, {
                      panelClass: 'default-dialog-wrapper',
                      width: '566px',
                      autoFocus: false,
                      data: {
                        title: this.isEdit ? translate('ADD_TENANT.CANCEL_EDIT_TENANT') : translate('ADD_TENANT.CANCEL_ADD_TENANT'),
                        message: this.isEdit ? translate('ADD_TENANT.EDIT_CANCEL_DESCRIPTION') : translate('ADD_TENANT.CANCEL_DESCRIPTION'),
                        confirmButtonText: translate('BUTTONS.YES'),
                        cancelButtonText: translate('BUTTONS.NO')                      }
                    }) .afterClosed()
                    .pipe(takeUntilDestroyed(this.destroyRef))
                    .subscribe(confirm => {
                      if (confirm) {
                        this.goToTenant();
                      }
                    })

                  }
                  resetFeature(): void {
                    this.isLoading = true;
                    this.isLoading = false;

                    this.count = this.count !== 1 ? 1 : 0;
                    this.featuresForm = this.formBuilder.group({
                      features: this.formBuilder.array(
                        this.featureList.map(feature => this.createFeatureFormGroup(feature))
                      )
                    });

                  }


                  createFeatureFormGroup(feature: any): FormGroup {
                    return this.formBuilder.group({
                      name: [feature.displayName],
                      description:[feature.description],
                      defaultEnabled: [
                        { value: this.isEdit ? feature.enabled === 'true' : feature.defaultEnabled === 'true', disabled: feature.modifiable === 'false' }
                      ],
                      modifiable: [feature.modifiable === 'true'],
                      pii: [
                        {
                          value: this.getZoneValue(feature, 'pii'),
                          disabled: !this.getZoneModifiable(feature, 'pii') || feature.modifiable === 'false' || !feature.modifiable
                        }
                      ],
                      piiOriginal: [this.getZoneValue(feature, 'pii')],
                      nonpii: [
                        {
                          value: this.getZoneValue(feature, 'nonpii'),
                          disabled: !this.getZoneModifiable(feature, 'nonpii') || feature.modifiable === 'false'|| !feature.modifiable
                        }
                      ],
                      nonpiiOriginal: [this.getZoneValue(feature, 'nonpii')],
                      prod: [
                        {
                          value: this.getZoneValue(feature, 'prod'),
                            disabled: !this.getZoneModifiable(feature, 'prod') || feature.modifiable === 'false'|| !feature.modifiable
                        }
                      ],
                      prodOriginal: [this.getZoneValue(feature, 'prod')]
                    });
                  }
toggleDefaultEnabled(feature: AbstractControl) {
  const modifiable = feature.get('modifiable')?.value === true || feature.get('modifiable')?.value === 'true';
  const ctrl = feature.get('defaultEnabled');
  if (modifiable && ctrl && !ctrl.disabled) {
    ctrl.setValue(!ctrl.value);
  }
  const fields = ['pii', 'nonpii', 'prod'];
  fields.forEach(field => {
    const control = feature.get(field);
    const original = feature.get(`${field}Original`)?.value;
    if (control && !control.disabled) {
      control.setValue(original);
    }
  });
}

  openTooltip(index: number, feature: any): void {
    this.activeTooltipIndex = index;
    this.tooltipData = {
      description: feature.get('description')?.value || '',
    };
    this.tooltipVisible = true;
  }

  openUrl(){
    this.urlService.openUrlInNewTab('https://dashboard.bankingcloud.temenos.com/userguide/docs/operator/tenant-onboarding-feature');
  }

selectSecondary() {
  const data = this.hasSecondary.find(item => item.value === 'true');
  this.selectedSecondary = data.label.toLowerCase();
}

 confirmRegion(currentStepVal: any): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        confirmButtonText: translate('TENANT_FORM.CONFIRM_BUTTON_REGION'),
        secondaryRegionWarn: true

      }
    })
    .afterClosed()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(confirm => {
      if (confirm) {
        this.currentStep = currentStepVal;
      }
    })
  }
  // Loads Azure regions for custom/single region selection.
  loadAzureCustomRegions() {
    this.cloudRegionService.getTenantRegions().pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((res: any[]) => {
      const azureRegions = res.filter( item => item.cloudProvider?.toLowerCase() === 'azure');
      if (!azureRegions.length) {
        this.primaryRegion = [];
        this.secondaryRegion = [];
        return;
      }
      this.primaryRegion = azureRegions.map(item => ({ name: item.name, displayName: item.displayName}));
      this.secondaryRegion = [...this.primaryRegion];
      if (this.isEdit) {
        this.cloudRegionForm.patchValue({
          primaryRegion: this.editTenantData?.primaryRegion,
          secondaryRegion: this.editTenantData?.secondaryRegion
        });
      }
    });
  }
  // Loads region lists based on selected type.
  loadAzureRegionsByType() {
    if (this.selectedRegion?.value === 'Region Pair') {
      this.primaryRegion = this.azurePrimaryRegion;
      this.secondaryRegion = this.azureSecondaryRegion;
    } else {
      this.loadAzureCustomRegions();
    }
  }


}





export interface Feature {
  name: string;
  pii: boolean;
  nonpii: boolean;
  prod: boolean;
  enabled: boolean;
  displayName: string;
  description: string;
  defaultEnabled: boolean;
  modifiable: boolean;
  dataZones: {
    dataZone: 'pii' | 'nonpii' | 'prod';
    defaultEnabled: boolean;
    modifiable: boolean;
  }[];
}
